import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { NestApiProvider } from "../nest-api";

@Injectable()
export class IntegrationApi {

  private service: string = '';
  private model: string = 'integration';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public asaren(menuCode: string): Observable<any> {
    const method: string = 'GET';
    const func: string = 'asaren';
    const params: any = {};
    const urlParams: any = { menuCode };
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

}


// WEBPACK FOOTER //
// ./src/shared/nestjs/integration/integration.ts